/**
 * Pure ping-pong patrol step. Extracted from SpiderManager so it can be
 * unit-tested in Node (no Phaser dependency).
 */
export function tickPatrol(
  offset: number,
  dir: 1 | -1,
  length: number
): { offset: number; dir: 1 | -1 } {
  // Defensive: zero/one-tile segments don't move. (The generator produces
  // length >= 2 today, but this guards against future tuning bugs.)
  if (length <= 1) return { offset, dir };
  let next = offset + dir;
  if (next < 0 || next >= length) {
    dir = (dir === 1 ? -1 : 1) as 1 | -1;
    next = offset + dir;
  }
  return { offset: next, dir };
}
